import React from "react";
import styles from './link.module.scss';
import { Link } from "react-router-dom";
import { KoText } from "packages/typography";

function HrefLink(props) {
  const { data } = props;
  return (
    <div className={styles.wrapper}>
      <Link target="_blank" to={`${data}`}>
        <KoText className={styles.text} text={data}/>
      </Link>
     
    </div>
  );
}
export default HrefLink;